import React, {useState} from "react";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import {Button, DialogActions, DialogContent, IconButton, Tooltip} from "@mui/material";
import {useTranslation} from "react-i18next";
import CustomDialog from "../custom-dialog";
import CustomDialogTitle from "../custom-dialog-title";
import OdataGraphViewer from "../odata-graph-viewer";

const OdataGraphViewerButton = ({baseurl, datasource, mainentityset, query}) => {
  const {t} = useTranslation();
  const [open, setOpen] = useState(false);
  return (
    query &&
    query.length > 1 && (
      <>
        <Tooltip title={t("components.odataGraphViewerButton.queryInfoBtn.title")}>
          <IconButton className="odata-graph-viewer__info-btn" onClick={() => setOpen(true)}>
            <ManageSearchIcon />
          </IconButton>
        </Tooltip>
        <CustomDialog open={open} onClose={() => setOpen(false)}>
          <CustomDialogTitle className="odata-graph-viewer__info-dialog__title" onClose={() => setOpen(false)}>
            {t("components.odataGraphViewerButton.queryInfoDialog.title")}
          </CustomDialogTitle>
          <DialogContent className="odata-graph-viewer__info-dialog__content">
            <OdataGraphViewer baseurl={baseurl} datasource={datasource} mainentityset={mainentityset} query={query} />
          </DialogContent>
          <DialogActions className="odata-graph-viewer__info-dialog__actions">
            <Button onClick={() => setOpen(false)}>{t("commons.confirm.close")}</Button>
          </DialogActions>
        </CustomDialog>
      </>
    )
  );
};

export default OdataGraphViewerButton;
